import { mergeToNewObject } from '../../../util/object.helpers'

import brandConfig from 'brandConfig'
import { RENAULT_BRAND_ID } from '../../../constants/brands'
import { isExistsElementFromList } from '../../../util/app/app.helpers'
import {
  ACCOUNT_ACTION,
  AUTH_ACTION,
  EXCHANGE_PROVIDER_ACTION,
  MAIN_PROFILE_ACTION,
  POINTS_REWARD_ACTION,
  PURCHASE_TIER_ACTION,
  REDEEM_ACTION,
  STAKING_ACTION
} from './../../../constants/actions'
import { getLWAConf } from '../../../util/local.helpers'

export const mainProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case MAIN_PROFILE_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA:
      return mergeToNewObject(state, { loading: true })

    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA_SUCCESS:
      return mergeToNewObject(state, {
        loading: false,
        ...extractMainData(payload)
      })

    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA_FAILED:
      return mergeToNewObject(state, { loading: false })

    case MAIN_PROFILE_ACTION.GET_TIERS:
      return mergeToNewObject(state, { loading: true })

    case MAIN_PROFILE_ACTION.GET_TIERS_SUCCESS:
      return mergeToNewObject(state, {
        loading: false,
        tiers: payload
      })

    case MAIN_PROFILE_ACTION.GET_TIERS_FAILED:
      return mergeToNewObject(state, { loading: false })

    case MAIN_PROFILE_ACTION.RESET_PREVIOUS_USER_POINTS_STATE:
      return mergeToNewObject(state, {
        previousUserPoints: state.currentUserPoints
      })

    case MAIN_PROFILE_ACTION.REFRESH_POINTS_BALANCE_SUCCESS:
      return syncCurrentUserPoints(state, payload)

    case AUTH_ACTION.ON_SIGN_OUT_SUCCESS:
      return INITIAL_STATE

    case REDEEM_ACTION.ON_GET_REWARD_TYPES_SUCCESS:
      return mergeToNewObject(state, { redemptionOptions: payload })

    case EXCHANGE_PROVIDER_ACTION.ON_GET_USER_MEMBERSHIPS_SUCCESS:
      return mergeToNewObject(state, { exchangeMemberships: payload })

    case POINTS_REWARD_ACTION.ON_RECEIVE_POINTS_FROM_CODE_SUCCESS:
      return mergeToNewObject(
        state,
        brandConfig.brandId === RENAULT_BRAND_ID &&
          isExistsElementFromList(
            brandConfig.campaignIdsToEnablePointBurn,
            payload?.campaign?.id
          )
          ? {
              isDisabledPointsBurn: false
            }
          : {}
      )

    case STAKING_ACTION.GET_USER_TIER_SUCCESS:
      return mergeToNewObject(state, {
        userTier: updateUserTier({ tiers: state.tiers[0], userTier: payload })
      })

    case ACCOUNT_ACTION.ON_CREATE_ACCOUNT_SUCCESS:
    case ACCOUNT_ACTION.GET_ACCOUNT_DETAILS_SUCCESS:
      return mergeToNewObject(state, { referral: '' })

    case REDEEM_ACTION.ON_GET_SIGNED_URL:
      return mergeToNewObject(state, { openingWindow: true })

    case REDEEM_ACTION.ON_GET_SIGNED_URL_SUCCESS:
    case REDEEM_ACTION.ON_GET_SIGNED_URL_FAILED:
      return mergeToNewObject(state, { openingWindow: false })

    case PURCHASE_TIER_ACTION.WITH_POINTS_SUCCESS:
      return mergeToNewObject(state, {
        userTier: {
          ...state.userTier,
          tier: { ...state.userTier.tier, ...payload }
        }
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  brandAppConfig: {},
  currentUserPoints: 0,
  previousUserPoints: 0,
  redemptionOptions: [],
  exchangeMemberships: {},
  exchangeWhitelist: {
    outgoing: [],
    incoming: []
  },
  loading: true,
  isNavMini: false,
  success: {},
  error: {},
  isDisabledPointsBurn: false,
  userTier: {
    totalFiatValue: 0,
    tier: {
      id: 1,
      name: 'Quartz',
      metadata: {
        loyalizeCashbackMultiplier: '1.00',
        ugcMultiplier: '0.25',
        referralMultiplier: '0.5',
        ugcMaxPostsRewarded: 1,
        coeStore: true, // Not being used, open COE for all tiers
        pointsToCrypto: false,
        pointsToMiles: false,
        pointsToPoints: false
      },
      fiat_threshold: 0
    }
  },
  tiers: [],
  referral: '',
  lwaConf: getLWAConf(),
  openingWindow: false
}

const extractMainData = (payload) => {
  const { pointsBalance, tiers, userTier } = payload
  return {
    ...payload,
    userTier: updateUserTier({ tiers, userTier }),
    currentUserPoints: pointsBalance?.balance || 0
  }
}

const syncCurrentUserPoints = (state, pointsBalance) => {
  const updatedState = {
    currentUserPoints: pointsBalance?.balance || 0,
    previousUserPoints: state.currentUserPoints
  }
  return mergeToNewObject(state, updatedState)
}

export const MAIN_PROFILE_DISPATCH = {
  LOADING: 'loading',
  IS_NAV_MINI: 'isNavMini',
  CURRENT_USER_POINTS: 'currentUserPoints',
  PREVIOUS_USER_POINTS: 'previousUserPoints',
  REFERRAL: 'referral',
  LWA_CONF: 'lwaConf'
}

const updateUserTier = ({ userTier, tiers }) => {
  return userTier ? userTier : { totalFiatValue: 0, tier: tiers[0] }
}
